<template>
    <div>
        <div class="mb-1">
            <b-row>
                <b-col xs="12" md="8">
                    <div v-if="!is_editing">
                        <itinerary-item :item="item"></itinerary-item>
                    </div>

                    <div class="edit-itinerary-item__form-wrapper" v-else>
                        <b-form @submit.prevent="onSubmit()">
                            <b-form-group>
                                <label>
                                    Title
                                </label>

                                <b-form-input
                                    class="tb-form-field"
                                    type="text"
                                    v-model="form.title"
                                    required>
                                </b-form-input>

                                <label>
                                    Time
                                </label>

                                <date-picker
                                    :datestring="form.time"
                                    :config="datepicker.config"
                                    @changed="(new_time) => {
                                form.time = new_time;
                            }">
                                </date-picker>

                                <label>
                                    Body
                                </label>

                                <b-form-textarea
                                    class="tb-form-field"
                                    v-model="form.body"
                                    required>
                                </b-form-textarea>

                                <label>
                                    Image
                                </label>

                                <alt-image-picker
                                    :width="768"
                                    :src="form.image"
                                    :text="'choose image'"
                                    @image-picked="(base64) => { form.image_base64 = base64; }"
                                    @image-removed="form.image = ''">
                                </alt-image-picker>
                            </b-form-group>

                            <b-button type="submit" variant="primary" class="tb-button tb-button--small tb-button--blue mt-3">
                                Submit
                            </b-button>
                        </b-form>
                    </div>
                </b-col>

                <b-col xs="12" md="4">
                    <div class="text-right itinerary-edit">
                        <a href="#" class="mr-2 tb-table__button tb-table__button--gold" @click.prevent="toggleEdit">
                            {{ !is_editing ? "Edit" : "Cancel editing" }}
                        </a>

                        <a href="#" class="tb-table__button tb-table__button--blue" @click.prevent="askDeleteItem">
                            Delete
                        </a>
                    </div>
                </b-col>
            </b-row>
        </div>

        <b-modal 
            v-model="show_delete_modal"
            id="delete-modal"
            title="Warning"
            @ok="deleteItem()"
            header-bg-variant="danger"
            header-text-variant="light"
            ok-title="Delete"
            ok-variant="danger">
            Are you sure you want to permanently delete this itinerary item?
        </b-modal>
    </div>
</template>

<script>
    import DatePicker from '@/components/DatePicker.vue';
    import ItineraryItem from '@/components/ItineraryItem.vue';
    // import SimpleImagePicker from "@/components/SimpleImagePicker";
    import AltImagePicker from "@/components/AltImagePicker";
    import { SERVER_TIME_FORMAT, LOCAL_TIME_FORMAT } from "@/constants.js";

    export default {
        props: ['item'],

        components: {
            ItineraryItem,
            DatePicker,
            // SimpleImagePicker,
            AltImagePicker
        },
        
        data() {
            return {
                is_editing: false,
                show_delete_modal: false,

                datepicker: {
                    config: {
                        format: SERVER_TIME_FORMAT,
                        display_format: LOCAL_TIME_FORMAT
                    }
                }
            }
        },
        
        computed: {
            form() {
                return {
                    ...this.item,
                }
            }
        },

        methods: {
            onSubmit() {
                this.$emit('changed', { ...this.form });
                this.is_editing = false;
            },

            toggleEdit() {
                this.is_editing = !this.is_editing;
            },

            askDeleteItem() {
                this.show_delete_modal = true;
            },
            
            deleteItem() {
                this.$emit('deleted', { ...this.form });
            }
        }
    }
</script>

<style scoped lang="scss">
    form {
        margin-bottom: 10px;
    }

    .form-group {
        margin-bottom: 0;
    }

    .alert {
        margin-top: 5px;
    }

    textarea {
        margin-bottom: 10px;
    }

    .edit-itinerary-item__form-wrapper {
        
    }

    .itinerary-edit {
        //margin-top: 0.5rem;
    }
</style>